import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareCheck"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM16.5574 9.91419L15.4968 8.85353L10.9968 13.3535L8.99678 11.3535L7.93612 12.4142L10.9968 15.4749L16.5574 9.91419Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareCheck;
